<template>
  <div class="wt2-translate-story wt2-modal-inner">
    <div class="-title wt2-text-l2">{{ title }}</div>
    <small>{{ message }}</small>
    <div class="-language">
      <span class="wt2-color-black">{{ label }}</span>
      <wt-dropdown
        :items="languages"
        :onClickItem="selectLanguage"
        :current-item-id="currentLanguage"
      />
    </div>
    <div class="-actions" v-tab-guard>
      <wt-button
        class="-min-width-unset"
        tabindex="0"
        type="transparent"
        :text="'generic.CANCEL' | culture"
        @click="closeModal"
      />
      <wt-button tabindex="-1" :text="buttonText" @click="translate" />
    </div>
  </div>
</template>

<script>
import app from 'app';

export default {
  store() {
    return app.rootStore;
  },

  props: {
    closeModal: {
      type: Function,
      required: true,
    },

    title: {
      type: String,
      default: app.culture.translateStoryDialog.title,
    },

    label: {
      type: String,
      default: app.culture.translateStoryDialog.target,
    },

    buttonText: {
      type: String,
      default: app.culture.translateStoryDialog.buttonText,
    },

    programmerLanguage: {
      type: String,
    },

    segments: {
      type: Array,
      required: true,
    },

    message: {
      type: String,
      required: true,
    },
  },

  methods: Object.assign({
    selectLanguage(lang) {
      this.currentLanguage = lang;
    },
    translate() {
      const translateModels = [];
      _.each(this.segments, (segment) => {
        _.each(segment.visualTracks, (track) => {
          let textOverlays = [];
          if (track.agd && !_.isEmpty(track.agd.textOverlays)) {
            textOverlays = track.agd.textOverlays;
          }
          _.each(textOverlays, (textOverlay) => {
            translateModels.push({
              guid: textOverlay.id,
              text: textOverlay.html,
            });
          });
        });
      });
      app.api.translateService
        .translate({ languageCode: this.currentLanguage, translateModels })
        .then((translations) => {
          app.timelineGateway.translateTimeline(translations);
        })
        .catch((error) => {
          app.dialog.error({
            type: app.dialog.types.ERROR_2,
            buttonYesText: 'Close',
            title: 'Translation Failed',
            description: 'An error occurred when trying to translate.',
            showContactCsm: true,
          });
        });
      this.closeModal();
    },
  }),

  data() {
    return {
      languages: [],
      currentLanguage: 'en',
    };
  },

  created() {
    app.api.translateService.supportedLanguages().then((languages) => {
      this.languages = languages.map((lang) => ({
        id: lang.language,
        label: lang.name,
      }));
      const lang = this.languages.find((lang) => {
        let language = this.programmerLanguage;
        if (language === 'CHINESE_SIMPLIFIED' || language === 'CHINESE') {
          language = 'CHINESE SIMPLIFIED';
        }
        if (language === 'CHINESE_TRADITIONAL') {
          language = 'CHINESE TRADITIONAL';
        }
        return lang.label.toUpperCase() === language;
      });
      if (lang) {
        this.currentLanguage = lang.id;
      } else if (this.languages.length) {
        this.currentLanguage = this.languages[0].id;
      }
    });
  },
};
</script>
